import FactCheckIcon from '@mui/icons-material/FactCheck'
import { List, ListItemButton, ListItemIcon, ListItemText, Tooltip } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { useLocation, useNavigate } from 'react-router-dom'

interface QualityControlContainerProps {
  onClose?: () => void
  isOpen?: boolean
}

const QualityControlContainer = ({ onClose, isOpen = true }: QualityControlContainerProps) => {
  const { t } = useTranslation()
  const location = useLocation()
  const navigate = useNavigate()
  const isSelected = location.pathname.startsWith('/quality-control')

  const handleClick = () => {
    onClose?.()
    navigate('/quality-control')
  }

  return (
    <List>
      <Tooltip title={!isOpen ? t('qualityControl.menuTitle') : ''} placement="right">
        <ListItemButton onClick={handleClick} selected={isSelected}>
          <ListItemIcon>
            <FactCheckIcon htmlColor="black" />
          </ListItemIcon>
          {isOpen && <ListItemText primary={t('qualityControl.menuTitle')} />}
        </ListItemButton>
      </Tooltip>
    </List>
  )
}

export default QualityControlContainer
